import React from 'react';
import PropTypes from 'prop-types';

export const SortCaret = ({...props}) => {
  return (
    <span className={props.className}>
      <span className='caret' style={{margin: '10px 5px'}} />
      {props.children}
    </span>
  );
};

SortCaret.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any
};



// WEBPACK FOOTER //
// ./src/Lots/Components/SortCaret.js